import { Module } from "wrapper6";

var $ = jQuery;

export default class Finance extends Module {

    ready(app) {

        const sparxpres = document.querySelector('.sparxpres_product');
        const financeButton = document.querySelector('.finans .button');

        if(sparxpres){
            document.querySelector('.finans').classList.remove('hidden');

            financeButton.addEventListener('click', () => {

                sparxpres.classList.add('show');
            });

            $(document).on('click', '.sparxpres_product.show', function(e){
                if (e.target.classList.contains('sparxpres_product')) {
                    sparxpres.classList.remove('show');
                }
            });

            // close modal on escape
            document.onkeydown = function (evt) {

                evt = evt || window.event;

                if (evt.keyCode === 27 && $('.sparxpres_product').classList.contains('show')) {

                    sparxpres.classList.remove('show');
                }
            };
        }

    }
}


// WEBPACK FOOTER //
// ./resources/js/modules/_finance.js